import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.draft ? _c(VRow, {
    staticClass: "mapper-config-builder",
    attrs: {
      "no-gutters": ""
    }
  }, [_c(VCol, {
    staticClass: "mapper-config-builder__form",
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_vm.draftErrors.length > 0 ? _c(VAlert, {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.validationError')) + "\n    ")]) : _vm._e(), _c('section', {
    staticClass: "mapper-config-builder__section"
  }, [_c('h4', {
    staticClass: "mapper-config-builder__section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.input.title')) + "\n      ")]), _c('p', {
    staticClass: "mapper-config-builder__section-hint text--secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.input.hint')) + "\n      ")]), _c(VSelect, {
    staticClass: "mb-4",
    attrs: {
      "value": _vm.draft.output,
      "items": _vm.outputShapeItems,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.input.outputShape'),
      "hint": _vm.$i18n_t('Bridges.mapperBuilder.input.outputShapeHint'),
      "disabled": _vm.disabled,
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "data-test": "mapper-builder-output-shape"
    },
    on: {
      "change": function ($event) {
        return _vm.setOutputShape($event);
      }
    }
  }), _c(VTextField, {
    attrs: {
      "value": _vm.draft.input.topicPattern,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.input.topicPattern'),
      "hint": _vm.$i18n_t('Bridges.mapperBuilder.input.topicPatternHint'),
      "error-messages": _vm.topicPatternError,
      "disabled": _vm.disabled,
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "data-test": "mapper-builder-topic-pattern"
    },
    on: {
      "input": function ($event) {
        return _vm.setInputField('topicPattern', $event);
      }
    }
  }), _c('div', {
    staticClass: "mapper-config-builder__subtitle text--secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.input.captures')) + "\n      ")]), _vm.draft.input.captures.length === 0 ? _c('p', {
    staticClass: "mapper-config-builder__section-hint text--secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.input.noCaptures')) + "\n      ")]) : _vm._e(), _vm._l(_vm.draft.input.captures, function (capture, index) {
    return _c('div', {
      key: capture.uiKey,
      staticClass: "mapper-config-builder__row"
    }, [_c(VTextField, {
      attrs: {
        "value": capture.name,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.input.captureName'),
        "disabled": _vm.disabled,
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "data-test": `mapper-builder-capture-${index}-name`
      },
      on: {
        "input": function ($event) {
          return _vm.setCaptureName(capture, $event);
        }
      }
    }), _c(VTextField, {
      staticClass: "mapper-config-builder__narrow",
      attrs: {
        "value": capture.index,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.input.captureGroup'),
        "disabled": _vm.disabled,
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "min": "0",
        "type": "number",
        "data-test": `mapper-builder-capture-${index}-group`
      },
      on: {
        "input": function ($event) {
          return _vm.setCaptureIndex(capture, $event);
        }
      }
    }), _c(VBtn, {
      attrs: {
        "disabled": _vm.disabled,
        "icon": "",
        "small": "",
        "title": _vm.$i18n_t('Bridges.mapperBuilder.input.removeCapture'),
        "data-test": `mapper-builder-capture-${index}-remove`
      },
      on: {
        "click": function ($event) {
          return _vm.removeCapture(index);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "size": "14"
      }
    }, [_vm._v("fal fa-trash-alt")])], 1)], 1);
  }), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled,
      "small": "",
      "text": "",
      "data-test": "mapper-builder-add-capture"
    },
    on: {
      "click": function ($event) {
        return _vm.addCapture();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "12"
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.input.addCapture')) + "\n      ")], 1), _c(VTextField, {
    staticClass: "mt-4",
    attrs: {
      "value": _vm.draft.input.root,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.input.root'),
      "hint": _vm.$i18n_t('Bridges.mapperBuilder.input.rootHint'),
      "disabled": _vm.disabled,
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "data-test": "mapper-builder-root"
    },
    on: {
      "input": function ($event) {
        return _vm.setInputField('root', $event);
      }
    }
  })], 2), _c('section', {
    staticClass: "mapper-config-builder__section"
  }, [_c('h4', {
    staticClass: "mapper-config-builder__section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.lookups.title')) + "\n      ")]), _c('p', {
    staticClass: "mapper-config-builder__section-hint text--secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.lookups.hint')) + "\n      ")]), _vm._l(_vm.draft.lookups, function (table, tableIndex) {
    return _c('div', {
      key: table.uiKey,
      staticClass: "mapper-config-builder__table"
    }, [_c('div', {
      staticClass: "mapper-config-builder__row"
    }, [_c(VTextField, {
      attrs: {
        "value": table.name,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.lookups.tableName'),
        "disabled": _vm.disabled,
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "data-test": `mapper-builder-lookup-${tableIndex}-name`
      },
      on: {
        "input": function ($event) {
          return _vm.setLookupName(table, $event);
        }
      }
    }), _c(VBtn, {
      attrs: {
        "disabled": _vm.disabled,
        "icon": "",
        "small": "",
        "title": _vm.$i18n_t('Bridges.mapperBuilder.lookups.removeTable'),
        "data-test": `mapper-builder-lookup-${tableIndex}-remove`
      },
      on: {
        "click": function ($event) {
          return _vm.removeLookupTable(tableIndex);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "size": "14"
      }
    }, [_vm._v("fal fa-trash-alt")])], 1)], 1), _vm._l(table.rows, function (row, rowIndex) {
      return _c('div', {
        key: row.uiKey,
        staticClass: "mapper-config-builder__row"
      }, [_c(VTextField, {
        attrs: {
          "value": row.key,
          "label": _vm.$i18n_t('Bridges.mapperBuilder.lookups.key'),
          "disabled": _vm.disabled,
          "dense": "",
          "hide-details": "",
          "outlined": "",
          "data-test": `mapper-builder-lookup-${tableIndex}-row-${rowIndex}-key`
        },
        on: {
          "input": function ($event) {
            return _vm.setLookupRowKey(row, $event);
          }
        }
      }), _c('mapper-literal-field', {
        attrs: {
          "value": row.value,
          "label": _vm.$i18n_t('Bridges.mapperBuilder.lookups.value'),
          "type-label": _vm.$i18n_t('Bridges.mapperBuilder.literal.type'),
          "disabled": _vm.disabled,
          "allow-json": "",
          "data-test": `mapper-builder-lookup-${tableIndex}-row-${rowIndex}-value`
        },
        on: {
          "change": function ($event) {
            return _vm.emitChange();
          }
        }
      }), _c(VBtn, {
        attrs: {
          "disabled": _vm.disabled,
          "icon": "",
          "small": "",
          "title": _vm.$i18n_t('Bridges.mapperBuilder.lookups.removeRow'),
          "data-test": `mapper-builder-lookup-${tableIndex}-row-${rowIndex}-remove`
        },
        on: {
          "click": function ($event) {
            return _vm.removeLookupRow(table, rowIndex);
          }
        }
      }, [_c(VIcon, {
        attrs: {
          "size": "14"
        }
      }, [_vm._v("fal fa-trash-alt")])], 1)], 1);
    }), _c(VBtn, {
      attrs: {
        "disabled": _vm.disabled,
        "small": "",
        "text": "",
        "data-test": `mapper-builder-lookup-${tableIndex}-add-row`
      },
      on: {
        "click": function ($event) {
          return _vm.addLookupRow(table);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "left": "",
        "size": "12"
      }
    }, [_vm._v("fal fa-plus")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.lookups.addRow')) + "\n        ")], 1)], 2);
  }), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled,
      "small": "",
      "text": "",
      "data-test": "mapper-builder-add-lookup"
    },
    on: {
      "click": function ($event) {
        return _vm.addLookupTable();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "12"
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.lookups.addTable')) + "\n      ")], 1)], 2), _c('section', {
    staticClass: "mapper-config-builder__section"
  }, [_c('h4', {
    staticClass: "mapper-config-builder__section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.title')) + "\n      ")]), _c('p', {
    staticClass: "mapper-config-builder__section-hint text--secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.hint')) + "\n      ")]), _vm.draft.emit.length === 0 ? _c('p', {
    staticClass: "mapper-config-builder__section-hint text--secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.noRules')) + "\n      ")]) : _vm._e(), _vm._l(_vm.draft.emit, function (rule, index) {
    return _c('mapper-emit-rule-card', {
      key: rule.uiKey,
      attrs: {
        "value": rule,
        "shape": _vm.draft.output,
        "index": index,
        "count": _vm.draft.emit.length,
        "captures": _vm.captureNames,
        "lookup-tables": _vm.lookupTableNames,
        "disabled": _vm.disabled
      },
      on: {
        "change": function ($event) {
          return _vm.emitChange();
        },
        "move": function ($event) {
          return _vm.moveEmitRule(index, $event);
        },
        "remove": function ($event) {
          return _vm.removeEmitRule(index);
        }
      }
    });
  }), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled,
      "small": "",
      "text": "",
      "data-test": "mapper-builder-add-emit"
    },
    on: {
      "click": function ($event) {
        return _vm.addEmitRule();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "12"
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.addRule')) + "\n      ")], 1)], 2)], 1), _c(VCol, {
    staticClass: "mapper-config-builder__preview",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('div', {
    staticClass: "mapper-config-builder__preview-inner"
  }, [_c('div', {
    staticClass: "mapper-config-builder__preview-header"
  }, [_c('h4', {
    staticClass: "mapper-config-builder__section-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.preview.title')) + "\n        ")]), _c(VBtnToggle, {
    attrs: {
      "value": _vm.format,
      "dense": "",
      "mandatory": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('update:format', $event);
      }
    }
  }, [_c(VBtn, {
    attrs: {
      "value": "json",
      "disabled": _vm.disabled,
      "small": "",
      "data-test": "mapper-builder-preview-json"
    }
  }, [_vm._v("JSON")]), _c(VBtn, {
    attrs: {
      "value": "yaml",
      "disabled": _vm.disabled,
      "small": "",
      "data-test": "mapper-builder-preview-yaml"
    }
  }, [_vm._v("YAML")])], 1)], 1), _c('p', {
    staticClass: "mapper-config-builder__section-hint text--secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.preview.hint')) + "\n      ")]), _c('pre', {
    staticClass: "mapper-config-builder__code",
    attrs: {
      "data-test": "mapper-builder-preview"
    }
  }, [_vm._v(_vm._s(_vm.previewText))])])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };